"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = exports.ErrorBoundaryHandler = void 0;
const react_1 = __importDefault(require("react"));
const router_1 = require("next/router");
const ErrorFallback_1 = __importDefault(require("./ErrorFallback"));
// Taken from https://github.com/vercel/next.js/blob/canary/packages/next/src/client/components/error-boundary.tsx
class ErrorBoundaryHandler extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.reset = () => {
            this.setState({ error: null });
        };
        this.state = { error: null, previousPathname: this.props.pathname };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    static getDerivedStateFromProps(props, state) {
        /**
         * Handles reset of the error boundary when a navigation happens.
         * Ensures the error boundary does not stay enabled when navigating to a new page.
         * Approach of setState in render is safe as it checks the previous pathname and then overrides
         * it as outlined in https://react.dev/reference/react/useState#storing-information-from-previous-renders
         */
        if (props.pathname !== state.previousPathname && state.error) {
            return {
                error: null,
                previousPathname: props.pathname
            };
        }
        return {
            error: state.error,
            previousPathname: props.pathname
        };
    }
    render() {
        if (this.state.error) {
            return (react_1.default.createElement(ErrorFallback_1.default, { error: this.state.error, reset: this.reset, ErrorComponent: this.props.errorComponent }));
        }
        return this.props.children;
    }
}
exports.ErrorBoundaryHandler = ErrorBoundaryHandler;
function ErrorBoundary({ errorComponent, children }) {
    const { pathname } = (0, router_1.useRouter)();
    return (react_1.default.createElement(ErrorBoundaryHandler, { pathname: pathname, errorComponent: errorComponent }, children));
}
exports.ErrorBoundary = ErrorBoundary;
